var map = {
	"./007-microphone-1.png": "./src/static/img/icon/007-microphone-1.png",
	"./010-home.png": "./src/static/img/icon/010-home.png",
	"./013-document-1.png": "./src/static/img/icon/013-document-1.png",
	"./014-document.png": "./src/static/img/icon/014-document.png",
	"./015-color-palette.png": "./src/static/img/icon/015-color-palette.png",
	"./017-video-camera.png": "./src/static/img/icon/017-video-camera.png",
	"./024-like.svg": "./src/static/img/icon/024-like.svg",
	"./1.svg": "./src/static/img/icon/1.svg",
	"./155-credit-card.svg": "./src/static/img/icon/155-credit-card.svg",
	"./2.svg": "./src/static/img/icon/2.svg",
	"./3.svg": "./src/static/img/icon/3.svg",
	"./4.svg": "./src/static/img/icon/4.svg",
	"./New Customer.svg": "./src/static/img/icon/New Customer.svg",
	"./NotOpen.svg": "./src/static/img/icon/NotOpen.svg",
	"./Opened.svg": "./src/static/img/icon/Opened.svg",
	"./Profit.svg": "./src/static/img/icon/Profit.svg",
	"./SalesRevenue.svg": "./src/static/img/icon/SalesRevenue.svg",
	"./Sent.svg": "./src/static/img/icon/Sent.svg",
	"./Slack.svg": "./src/static/img/icon/Slack.svg",
	"./address.svg": "./src/static/img/icon/address.svg",
	"./adobe.svg": "./src/static/img/icon/adobe.svg",
	"./arrow-left.svg": "./src/static/img/icon/arrow-left.svg",
	"./arrow-right.svg": "./src/static/img/icon/arrow-right.svg",
	"./book.svg": "./src/static/img/icon/book.svg",
	"./camera.svg": "./src/static/img/icon/camera.svg",
	"./chat.svg": "./src/static/img/icon/chat.svg",
	"./clipboard.svg": "./src/static/img/icon/clipboard.svg",
	"./cloud.svg": "./src/static/img/icon/cloud.svg",
	"./columns.svg": "./src/static/img/icon/columns.svg",
	"./documentation.svg": "./src/static/img/icon/documentation.svg",
	"./file.svg": "./src/static/img/icon/file.svg",
	"./flat.svg": "./src/static/img/icon/flat.svg",
	"./headphone.svg": "./src/static/img/icon/headphone.svg",
	"./iconfinder_trello_2317760.svg": "./src/static/img/icon/iconfinder_trello_2317760.svg",
	"./idea.svg": "./src/static/img/icon/idea.svg",
	"./image.png": "./src/static/img/icon/image.png",
	"./image.svg": "./src/static/img/icon/image.svg",
	"./label.png": "./src/static/img/icon/label.png",
	"./layers.svg": "./src/static/img/icon/layers.svg",
	"./left.svg": "./src/static/img/icon/left.svg",
	"./logo2.svg": "./src/static/img/icon/logo2.svg",
	"./logo3.svg": "./src/static/img/icon/logo3.svg",
	"./logo4.svg": "./src/static/img/icon/logo4.svg",
	"./logo5.svg": "./src/static/img/icon/logo5.svg",
	"./logo6.svg": "./src/static/img/icon/logo6.svg",
	"./logoIn.svg": "./src/static/img/icon/logoIn.svg",
	"./paint.svg": "./src/static/img/icon/paint.svg",
	"./protection.svg": "./src/static/img/icon/protection.svg",
	"./quote.png": "./src/static/img/icon/quote.png",
	"./repeat.svg": "./src/static/img/icon/repeat.svg",
	"./right.svg": "./src/static/img/icon/right.svg",
	"./strategy.svg": "./src/static/img/icon/strategy.svg",
	"./theme.svg": "./src/static/img/icon/theme.svg",
	"./user.svg": "./src/static/img/icon/user.svg",
	"./water-fall.svg": "./src/static/img/icon/water-fall.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/static/img/icon sync recursive ^\\.\\/.*$";